<template>
  <div class="menus">
    <div
      class="menu"
      :class="{ parent: parent == menu.value }"
      v-for="menu in data"
      :key="menu.value"
    >
      <div
        class="label cp"
        :class="{ active: component == menu.value }"
        @click="handleChange(menu)"
      >
        {{ $t(menu.label) }}
      </div>
      <div class="line" v-if="menu.children"></div>
      <sidebar-menu
        @change="handleChange"
        :data="menu.children"
        :component="component"
        :parent="parent"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'sidebar-menu',
  components: {},
  props: ['data', 'component', 'parent'],
  methods: {
    handleChange(val) {
      this.$emit('change', val)
    },
  },
}
</script>

<style lang="scss" scoped>
.menus {
  width: fit-content;
  display: flex;
  border-left: 2px solid #fff;
  flex-direction: column;
  text-align: start;
  margin-left: 1em;
  .menu {
    position: relative;
    padding-right: 1em;
    .label {
      text-align: center;
      width: 6.5em;
      height: fit-content;
      background-color: rgba($color: #fff5f5, $alpha: 0.9);
      border: 2px solid transparent;
      border-left: 0;
      margin-bottom: 1em;
      padding: 0.5em;
    }
    .active {
      background-color: var(--red-color);
      border-color: #fff;
      color: #fff;
    }
    .line {
      position: absolute;
      top: calc(100% - 1em);
      left: 0;
      height: 0;
      background-color: #fff;
      width: 100%;
    }
    &:last-child {
      .label {
        margin-bottom: 0;
      }
      .line {
        top: 100%;
      }
    }
    .menus {
      position: absolute;
      top: -100%;
      left: 100%;
      width: 0;
      border-left: 0;
      margin-left: 0;
      overflow: hidden;
    }
  }
  .parent {
    .line {
      height: 2px;
    }
    .menus {
      width: fit-content;
      border-left: 2px solid #fff;
      .label {
        margin-bottom: 1em;
      }
      .menu:last-child {
        .label {
          margin-bottom: 0;
        }
      }
    }
  }
  .cp:hover {
    border-color: #fff;
    background-color: var(--red-color);
    color: #fff;
  }
}
</style>

<style lang="scss">
.menu2 {
  .menus {
    .menu {
      .label {
        background-color: rgba($color: #fff0fe, $alpha: 0.9);
      }
      .active {
        background-color: var(--exp-color);
      }
    }
    .cp:hover {
      background-color: var(--exp-color);
    }
  }
}
</style>